import {
  BookkeepersManagementCreateTaskDocumentDocument,
  BookkeepersManagementCreateTaskDocumentMutation,
  BookkeepersManagementCreateTaskDocumentMutationVariables,
  BookkeepersManagementTaskDocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

export type CreateTaskDocumentPayload =
  BookkeepersManagementCreateTaskDocumentMutation['bookkeepersManagementMutations']['createBookkeepersmanagementTaskTaskDocument']

export const useCreateTaskDocument = () => {
  const isBookkeeperView = useBookkeeperView()
  const [createTaskDocument, { loading }] = useMutation(
    BookkeepersManagementCreateTaskDocumentDocument,
    {
      context: {
        isBookkeeperView,
      },
      extractorFn: (data: BookkeepersManagementCreateTaskDocumentMutation) =>
        data.bookkeepersManagementMutations.createBookkeepersmanagementTaskTaskDocument,
    }
  )

  const create = (variables: BookkeepersManagementCreateTaskDocumentMutationVariables) => {
    return createTaskDocument({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: BookkeepersManagementTaskDocumentsDocument,
          variables: { incidenceId: variables.incidenceId },
        },
      ],
    })
  }

  return {
    loading,
    create,
  }
}
